import { useMutation } from "@/compat/reactQuery";
import templateFormHistoryService from "../../services/templateFormHistoryService";

const useDeleteTemplateFormHistoryAttachment = () => useMutation(templateFormHistoryService.deleteHistoricAttachment)

export default useDeleteTemplateFormHistoryAttachment;